import { useCallback } from "react";

import { FieldOption } from "components/FieldSelect/FieldSelect";
import { OnEdit } from "components/EditableTable/EditableTable";
import { withSelectedOption } from "services/withSelectedOption";
import { convertToBooleanAndAddToObject } from "services/convertToBooleanAndAddToObject";

export function useHandleOKBooleanField() {
	return useCallback(function handleOK<T>(
		row: T,
		newOptions: FieldOption[],
		rowKey: keyof T,
		onEdit: OnEdit<T>
	) {
		withSelectedOption(newOptions, val => {
			const newData = convertToBooleanAndAddToObject(row, val, rowKey);
			onEdit([{ old: row, new: newData }]);
		});
	},
	[]);
}
